import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFilteredOrders,
  selectHoverOrder
} from 'selectors/ordersSelector';
import { Polyline, Marker, Pane, Popup } from 'react-leaflet';

import L from 'leaflet';

import { orderStatuses } from '../../constants/orderConstants';
import { getOrder } from 'actions/orderActions';
import { missionPointsCollectionToPolyline } from 'utils/parsingUtils';
import ReactDOMServer from 'react-dom/server';
import { indexPriority } from 'utils/ui';
import { routePriority, StatusMarker } from './OrdersMap';
import { amber } from '@mui/material/colors';

export const RouteElement = (props: { showStatuses?: string[] }) => {
  const dispatch = useDispatch();
  const orders = useSelector(selectFilteredOrders);
  const hoveredOrder = useSelector(selectHoverOrder);
  return (
    <>
      {orders
        ?.filter(
          order =>
            props.showStatuses?.includes(order.status) ||
            hoveredOrder === order.id
        )
        .map((order, i) => {
          const hovered = hoveredOrder === order.id;

          if (order.dropLatlng) {
            const statusIcon = L.divIcon({
              className: 'custom-icon',
              html: ReactDOMServer.renderToString(
                <StatusMarker
                  style={{
                    zIndex: hovered ? indexPriority(3) : indexPriority(4)
                  }}
                  hovered={hovered}
                  status={order.status}
                />
              )
            });
            const missionRoute = (order as any)?.geojsonLine
              ? missionPointsCollectionToPolyline((order as any)?.geojsonLine)
              : null;

            const onClickOrder = () => dispatch(getOrder(order.id));

            return (
              <div key={`${order.id}-${i}-div`}>
                {missionRoute?.length ? (
                  <Pane
                    name={`order-route-line-${order.id}`}
                    key={`${order.id}${hovered}`}
                    style={{
                      zIndex: 350
                    }}>
                    <Polyline
                      weight={hovered ? 5 : 3}
                      positions={(order as any)?.geojsonLine.features?.[0].geometry.coordinates.map(
                        point => [point[1], point[0]]
                      )}
                      color={
                        hovered ? amber[300] : orderStatuses[order.status].color
                      }
                    />
                  </Pane>
                ) : null}
                <Pane
                  name={`order-route-marker-${order.id}`}
                  key={`${order.id}2`}
                  style={{
                    zIndex: hovered ? indexPriority(3) : indexPriority(4)
                  }}>
                  <Marker
                    // @ts-ignore
                    position={order.dropLatlng
                      .split(',')
                      .map(coordinate => coordinate.trim())}
                    onClick={onClickOrder}
                    icon={statusIcon}
                    onmouseover={e => e.target.openPopup()}
                    onmouseout={e => e.target.closePopup()}>
                    <Popup>
                      <div key="ordermap">Order: #{order.id.slice(0, 8)}</div>
                      <div key="orderstatus">Status: {order.status}</div>
                      <div key="ordereircode">Eircode: {order.eircode}</div>
                    </Popup>
                  </Marker>
                </Pane>
              </div>
            );
          }
          return null;
        })}
    </>
  );
};
